import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

interface GcpSectionErrorBannerProps {
  title: string
  error: string
  missingRoleHint?: string | null
}

export default function GcpSectionErrorBanner({
  title,
  error,
  missingRoleHint,
}: GcpSectionErrorBannerProps) {
  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <div className="flex items-start gap-2">
        <ExclamationTriangleIcon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden />
        <div>
          <p className="font-medium">{title}</p>
          <p className="mt-1">{error}</p>
          {missingRoleHint ? (
            <p className="mt-1 text-amber-800">
              Missing IAM role: <code className="text-xs">{missingRoleHint}</code>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  )
}
